import { createWithEqualityFn } from 'zustand/traditional'

const useScandit = createWithEqualityFn((set) => ({
  isLoaded: false,
  sdk: null,
  setSdk: (sdk) => set({ sdk , isLoaded: true}),
}))

export default useScandit